import { useState } from 'react'
import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { FullTrainingFragment } from 'generated/resources/graphql'

import type { TrainingsTrainingClass } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

import { Content } from './content'
import { EmptyState } from './empty-state'
import { Header } from './header'

export function FinalizarGrupoFormativoExport() {
  const { classes, training } = useOutletContext<{
    classes?: TrainingsTrainingClass[]
    training: FullTrainingFragment
  }>()

  if (!classes) return null

  if (classes?.length === 0)
    return (
      <Box paddingTop="s32" gap="s16" alignItems="center">
        <EmptyState />
      </Box>
    )

  return <ExportDashboard classes={classes} training={training} />
}

function ExportDashboard({
  classes,
  training,
}: {
  classes: TrainingsTrainingClass[]
  training: FullTrainingFragment
}) {
  const [selectedClassId, setSelectedClassId] = useState<number | undefined>(
    classes.at(0)?.id ? Number(classes.at(0)?.id) : undefined
  )
  const [validate, setValidate] = useState(false)
  return (
    <Box gap="s16">
      <Header
        onError={() => {
          setValidate(true)
        }}
        selectedClassId={selectedClassId}
      />
      <Content
        classes={classes}
        training={training}
        selectedClassId={Number(selectedClassId)}
        setSelectedClassId={setSelectedClassId}
        validate={validate}
      />
    </Box>
  )
}
